import { LoadTypeDirection } from '@nova/core';

import type { ILoadType } from '@nova/core';

export type LoadTypeDetails = Pick<ILoadType, 'id' | 'warehouseId'> &
  Partial<{
    name: ILoadType['name'] | null;
    duration_min: ILoadType['duration_min'] | null;
    direction: ILoadType['direction'] | null;
  }>;

export function getDirectionIcon(loadTypeDirection: LoadTypeDirection) {
  if (!loadTypeDirection) {
    return undefined;
  }

  if (loadTypeDirection === LoadTypeDirection.Inbound) {
    return 'mdi-menu-up';
  }

  if (loadTypeDirection === LoadTypeDirection.Outbound) {
    return 'mdi-menu-down';
  }

  if (loadTypeDirection === LoadTypeDirection.InOut) {
    return 'mdi-menu-swap';
  }

  return undefined;
}

export function getDirectionIconColor(loadTypeDirection: LoadTypeDirection) {
  if (!loadTypeDirection) {
    return undefined;
  }

  if (loadTypeDirection === LoadTypeDirection.Inbound) {
    return 'info';
  }

  if (loadTypeDirection === LoadTypeDirection.Outbound) {
    return 'warning';
  }

  return 'text--color-black';
}
